<!--
<template>
  <div>
    <h2>Control Panel</h2>
    <button class="btn btn-outline-secondary" @click="fetchDeviceList">Refresh</button>
    <button class="btn btn-outline-secondary" @click="logout">Logout</button>
    <h3>Device List</h3>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Name</th>
          <th scope="col">Model</th>
          <th scope="col">Serial</th>
          <th scope="col">Firmware Ver</th>
          <th scope="col">Hardware Ver</th>
          <th scope="col">Bootloader Ver</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(device, index) in devices" :key="device.ser">
          <th scope="row">{{ index+1 }}</th>
          <td>{{ device.name }}</td>
          <td>{{ device.model }}</td>
          <td>{{ device.ser }}</td>
          <td>{{ device.fwver }}</td>
          <td>{{ device.hwver }}</td>
          <td>{{ device.bver }}</td>
          <td>
            <button class="btn btn-outline-secondary" @click="deleteDevice(device.ser)">Delete</button>
            <button class="btn btn-outline-secondary" @click="showDevice(device)">Show</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
-->

<template>
  <div class="container mt-5">
    <h2 class="text-center">Control Panel</h2>
    <div class="d-flex justify-content-center mb-3">
      <button class="btn btn-outline-secondary me-2" @click="fetchDeviceList">Refresh</button>
      <button class="btn btn-outline-secondary" @click="logout">Logout</button>
    </div>
    <h3 class="text-center">Device List</h3>
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Model</th>
            <th scope="col">Serial</th>
            <th scope="col">Firmware Ver</th>
            <th scope="col">Hardware Ver</th>
            <th scope="col">Bootloader Ver</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(device, index) in devices" :key="device.ser">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ device.name }}</td>
            <td>{{ device.model }}</td>
            <td>{{ device.ser }}</td>
            <td>{{ device.fwver }}</td>
            <td>{{ device.hwver }}</td>
            <td>{{ device.bver }}</td>
            <td>
              <button class="btn btn-outline-secondary me-2" @click="deleteDevice(device.ser)">Delete</button>
              <button class="btn btn-outline-secondary" @click="showDevice(device)">Show</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { ref, onMounted, onUnmounted } from 'vue'
import { getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { Preferences } from '@capacitor/preferences'

export default {
  setup() {
    const token = ref(localStorage.getItem('token'))
    const devices = ref([])
    const currentInstance = getCurrentInstance()
    const PhiveHost = currentInstance.appContext.config.globalProperties.PhiveHost
    const router = useRouter()

    const ToLoginPage = async (clean) => {
      await Preferences.remove({ key: 'username' });
      await Preferences.remove({ key: 'password' });
      localStorage.removeItem('token')
      router.push('/login')
    };

    const updateToken = async () => {
      if (!token.value) {
        //alert('Please login first')
        ToLoginPage(1)
        return
      }

      try {
        // stop the device update interval when token is updated
        clearInterval(deviceIntervalId)
        const response = await axios.post(PhiveHost+'/cgi-bin/login_update.cgi', { token: token.value }, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response.data.code === 0) {
          token.value = response.data.token
          localStorage.setItem('token', token.value)
          // Start the device update interval with the new token
          deviceIntervalId = setInterval(fetchDeviceList, 10000)
          fetchDeviceList() // Fetch device list immediately with the new token
        } else {
          alert(response.data.msg || 'Token update failed')
          //router.push('/login')
          ToLoginPage(1)
        }
      } catch (error) {
        console.error(error)
        alert('Token update failed')
        //router.push('/login')
        //ToLoginPage(1)
      }
    }

    const fetchDeviceList = async () => {
      if (!token.value) {
        //alert('Please login first')
        //router.push('/login')
        ToLoginPage(1)
        return
      }

      try {
        const response = await axios.post(PhiveHost+'/cgi-bin/devlist.cgi', { token: token.value }, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response.data.code === 0) {
          devices.value = response.data.devices
        } else {
          //alert(response.data.msg || 'Token failed')
          //router.push('/login')
          ToLoginPage(1)
        }
        
      } catch (error) {
        console.error(error)
        alert('Failed to fetch device list')
      }
    }

    const deleteDevice = async (devid) => {
      if (!token.value) {
        //alert('Please login first')
        //router.push('/login')
        ToLoginPage(1)
        return
      }

      try {
        const response = await axios.post(PhiveHost+'/cgi-bin/devdel.cgi', {
          token: token.value,
          devid: devid
        }, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response.data.code === 0) {
          alert('Device deleted successfully')
          fetchDeviceList()
        } else {
          alert(response.data.msg || 'Device deletion failed')
        }
      } catch (error) {
        console.error(error)
        alert('Device deletion failed')
      }
    }

    const showDevice = (dev) => {
      // Redirect to the edit device page and pass the device as a route parameter
      console.log("Toppage devid", dev.ser);
      router.push({ name: 'showDevice', params: {devid: dev.ser}, state:{modelname: dev.model}})
    }

    const logout = async () => {
      await Preferences.remove({ key: 'username' });
      await Preferences.remove({ key: 'password' });
      if (!token.value) {
        router.push('/login')
        return
      }

      devices.value = []
      clearInterval(tokenIntervalId)
      clearInterval(deviceIntervalId)

      try {
        const response = await axios.post(PhiveHost+'/cgi-bin/logout.cgi', { token: token.value }, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})

        localStorage.removeItem('token')
        router.push('/login')
        
      } catch (error) {
        console.error(error)
      }
    }

    let tokenIntervalId
    let deviceIntervalId

    onMounted(() => {
      tokenIntervalId = setInterval(updateToken, 60000) // Update token every minute
      deviceIntervalId = setInterval(fetchDeviceList, 10000) // Update device list every 10 seconds
      fetchDeviceList() // Fetch device list when the component mounts
    })

    onUnmounted(() => {
      clearInterval(tokenIntervalId)
      clearInterval(deviceIntervalId)
    })

    return {
      token,
      devices,
      updateToken,
      fetchDeviceList,
      deleteDevice,
      showDevice,
      logout,
      ToLoginPage,
    }
  }
}
</script>
